module.exports = angular.module('msi.shipments', [
  require('@ordergroove/brandy/src/app/utils'),
  require('@ordergroove/brandy/src/app/products'),
  require('@ordergroove/brandy/src/app/addresses'),
  require('@ordergroove/brandy/src/app/payments'),
  require('@ordergroove/brandy/src/app/subscriptions'),
  require('@ordergroove/brandy/src/app/shipping-address'),
  require('@ordergroove/brandy/src/app/datepicker'),
  require('@ordergroove/brandy/src/app/upsell'),
  require('@ordergroove/brandy/src/app/datepicker'),
  require('@ordergroove/brandy/src/app/dropdown'),
  require('@ordergroove/brandy/src/app/analytics'),
  require('./shipments.service'),
  require('./shipments-orchestrator.service'),
  require('./shipment-pricing'),
  require('./change-shipment-date'),
  require('./send-shipment-now'),
  require('./skip-shipment'),
  require('./sent-shipment'),
  require('./unsent-shipment')
]).name;
